import type { NavSectionProps } from 'src/components/nav-section';

import { paths } from 'src/routes/paths';

import { CONFIG } from 'src/global-config';

import { Image } from 'src/components/image';
import { SvgColor } from 'src/components/svg-color';

// ----------------------------------------------------------------------

const icon = (name: string) =>
  name.startsWith('ic-variance') ? (
    <Image src={`${CONFIG.assetsDir}/assets/icons/navbar/${name}.svg`} />
  ) : (
    <SvgColor src={`${CONFIG.assetsDir}/assets/icons/navbar/${name}.svg`} />
  );

const ICONS = {
  job: icon('ic-job'),
  blog: icon('ic-blog'),
  chat: icon('ic-chat'),
  mail: icon('ic-mail'),
  user: icon('ic-user'),
  file: icon('ic-file'),
  lock: icon('ic-lock'),
  tour: icon('ic-tour'),
  order: icon('ic-order'),
  label: icon('ic-label'),
  blank: icon('ic-blank'),
  kanban: icon('ic-kanban'),
  folder: icon('ic-folder'),
  course: icon('ic-course'),
  banking: icon('ic-banking'),
  booking: icon('ic-booking'),
  invoice: icon('ic-invoice'),
  product: icon('ic-product'),
  calendar: icon('ic-calendar'),
  disabled: icon('ic-disabled'),
  external: icon('ic-external'),
  menuItem: icon('ic-menu-item'),
  ecommerce: icon('ic-ecommerce'),
  analytics: icon('ic-analytics'),
  dashboard: icon('ic-dashboard'),
  parameter: icon('ic-parameter'),
  all: icon('ic-all'),
  mine: icon('ic-mine'),
  unassigned: icon('ic-unassigned'),
  whatsappbusiness: icon('ic-variance-whatsapp-business'),
  email: icon('ic-variance-mail'),
  voice: icon('ic-variance-voice'),
  livechat: icon('ic-variance-livechat'),
  setting: icon('ic-settings'),
  campaign: icon('ic-campaign'),
  account: icon('ic-account'),
  channel: icon('ic-channel'),
  tenant: icon('mdi--account-multiple'),
  ticket: icon('mdi--ticket-confirmation-outline'),
  report: icon('ic-report'),
};

// ----------------------------------------------------------------------

export const navData: NavSectionProps['data'] = [
  /**
   * Overview
   */
  // {
  //   subheader: 'Overview',
  //   items: [
  //     {
  //       title: 'One',
  //       path: paths.dashboard.root,
  //       icon: ICONS.dashboard,
  //       info: <Label>v{CONFIG.appVersion}</Label>,
  //     },
  //     { title: 'Two', path: paths.dashboard.two, icon: ICONS.ecommerce },
  //     { title: 'Three', path: paths.dashboard.three, icon: ICONS.analytics },
  //   ],
  // },
  /**
   * Management
   */
  {
    // subheader: 'CRM',
    items: [
      {
        title: 'Dashboard',
        path: paths.dashboard.root,
        icon: ICONS.dashboard,
        id: 'dashboard',
        // children: [
        //   { title: 'List', path: paths.account.list },
        //   { title: 'Details', path: paths.account.demo.details },
        // ],
      },
      {
        title: 'Accounts',
        path: paths.account.root,
        icon: ICONS.account,
        id: 'company',
        // children: [
        //   { title: 'List', path: paths.account.list },
        //   { title: 'Details', path: paths.account.demo.details },
        // ],
      },
      {
        title: 'Contacts',
        path: paths.contact.root,
        icon: ICONS.user,
        id: 'contact',
        // children: [
        //   { title: 'List', path: paths.contact.list },
        //   { title: 'Details', path: paths.contact.demo.details },
        // ],
      },

      // {
      //   title: 'Form',
      //   path: paths.form.root,
      //   icon: ICONS.invoice,
      // },
      {
        title: 'Inbox',
        path: paths.chat.root,
        icon: ICONS.chat,
        id: 'inbox',
      },
      {
        title: 'Campaign',
        path: paths.campaign.root,
        icon: ICONS.campaign,
        id: 'campaign',
      },
      {
        title: 'Channel',
        path: paths.channel.root,
        icon: ICONS.channel,
        id: 'channel',
      },
      {
        title: 'Tickets',
        path: paths.ticket.root,
        icon: ICONS.ticket,
        id: 'ticket',
      },
      {
        title: 'Report',
        path: paths.report.root,
        icon: ICONS.report,
        id: 'report',
        children: [{ title: 'call_logs', path: paths.report['call-logs'], id: 'call' }],
      },
      {
        title: 'Setting',
        path: paths.setting.root,
        icon: ICONS.setting,
        id: 'setting',
        children: [
          { title: 'Organization', path: paths.setting.organization, id: 'organization' },
          { title: 'Users', path: paths.setting.user.root, id: 'user' },
          { title: 'Teams', path: paths.setting.teams.root, id: 'team' },
          { title: 'custom_labels', path: paths.setting['custom-labels'], id: 'label' },
          { title: 'Template', path: paths.setting.template, id: 'tamplate' },
          { title: 'whatsapp_templates', path: paths.setting['whatsapp-template'], id: 'template' },
          { title: 'billing', path: paths.setting['billing'], id: 'bill' },
          {
            title: 'Webhooks',
            path: paths.setting.webhook,

            id: 'webhook',
          },
          // { title: 'did_manage', path: paths.setting['did-manage'] },
          // { title: 'User Profie', path: paths.setting.root },
          // { title: 'Addons', path: paths.setting.root },
          // { title: 'Invoices', path: paths.setting.root },
        ],
      },
      {
        title: 'Tenants',
        path: paths.tenant.root,
        icon: ICONS.tenant,
        id: 'tenants',
      },
    ],
  },
];

// ------------------------------------------------------------------

export const chatPannelData: NavSectionProps['data'] = [
  {
    subheader: 'Inbox',
    items: [
      {
        title: 'All',
        path: paths.chat.all,
        icon: ICONS.all,
      },
      {
        title: 'Mine',
        path: paths.chat.mine,
        icon: ICONS.mine,
      },
      {
        title: 'Unassigned',
        path: paths.chat.unassigned,
        icon: ICONS.unassigned,
      },
    ],
  },
  {
    subheader: 'Channels',
    items: [
      {
        title: 'VARIANCE_WHATSAPP_BUSINESS',
        path: paths.chat.whatsapp,
        icon: ICONS.whatsappbusiness,
        type: 'WHATSAPP',
      },
      {
        title: 'VARIANCE_EMAIL',
        path: paths.chat.email,
        icon: ICONS.email,
        type: 'EMAIL',
      },
      {
        title: 'VARIANCE_VOICE',
        path: paths.chat.voice,
        icon: ICONS.voice,
        type: 'VOICE',
      },
      {
        title: 'VARIANCE_LIVE_CHAT',
        path: paths.chat['live-chat'],
        icon: ICONS.livechat,
        type: 'LIVE_CHAT',
      },
    ],
  },
];
